import { Modal } from "newui/components/ui/Modal";

export interface DeleteRowModalProps {
	isDeleting?: boolean;
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const DeleteRowModal: React.FC<DeleteRowModalProps> = ({
	isDeleting = false,
	isOpen,
	onClose,
	onConfirm,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Delete Row"
			iconType="error"
			modalType="standard"
			closeOnEsc
			closeOnOverlayClick
			size="sm"
			primaryButton={{
				text: isDeleting ? "Deleting..." : "Delete",
				onClick: onConfirm,
			}}
			secondaryButton={{
				text: "Cancel",
				onClick: onClose,
			}}
		>
			<div className="text-center font-roboto text-sm text-tertiary-600">
				<p className="mb-2">
					Are you sure you want to delete this row?
				</p>
				<p>This action cannot be undone.</p>
			</div>
		</Modal>
	);
};

export { DeleteRowModal };
